<template>
  <div class="login-page">
    <div class="login-card">
      <div class="brand-mark">Ledger</div>
      <h1>轻奢鞋服记账工具</h1>
      <p>记录买入、卖出、库存与利润，方便个人对账。</p>
      <el-form ref="form" :model="form" :rules="rules" @keyup.enter.native="submit">
        <el-form-item prop="username">
          <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="用户名" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="密码" type="password" show-password />
        </el-form-item>
        <el-button type="primary" :loading="loading" class="login-btn" @click="submit">登录</el-button>
      </el-form>
      <div class="login-tip">默认账号：admin / admin123</div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/auth'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: { username: 'admin', password: 'admin123' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const data = await login(this.form)
          this.$store.commit('SET_LOGIN', data)
          this.$message.success('登录成功')
          this.$router.replace('/dashboard')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at top left, #dbeafe, transparent 34%), linear-gradient(135deg, #f8fafc, #eef2ff);
}
.login-card {
  width: 420px;
  max-width: 100%;
  padding: 36px;
  background: rgba(255,255,255,.9);
  border: 1px solid #e4e4e7;
  border-radius: 24px;
  box-shadow: 0 24px 80px rgba(15, 23, 42, .12);
}
.brand-mark {
  display: inline-flex;
  height: 34px;
  align-items: center;
  padding: 0 12px;
  border-radius: 999px;
  background: #18181b;
  color: #fff;
  font-weight: 700;
  letter-spacing: .5px;
}
h1 { margin: 20px 0 8px; font-size: 28px; }
p { margin: 0 0 26px; color: #71717a; line-height: 1.6; }
.login-btn { width: 100%; height: 42px; }
.login-tip { margin-top: 16px; font-size: 13px; color: #71717a; text-align: center; }
</style>
